
import './scss/style.scss'

document.addEventListener('DOMContentLoaded', function() {

})

/*
// youtube video
// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 3. This function creates an <iframe> (and YouTube player)
//    after the API code downloads.
var player;
window.onYouTubeIframeAPIReady = function() {
    player = new YT.Player('video', {
        height: '360',
        width: '640',
        videoId: 'hS9v_F51GyY',
        events: {
            'onReady': onPlayerReady
        }
    });
}

// 4. The API will call this function when the video player is ready.
function onPlayerReady(event) {
    let play = document.querySelector('.video-play')
    play.addEventListener('click', () => {
        play.style.display = 'none'
        event.target.playVideo()
    })
}
*/